<template>
	<div class="container-fluid h-100 my-2">
		<div class="row justify-content-center align-items-center h-100">
			<div class="col-auto">
				<div class="box" id="login">

					<div v-if="auto_connect || connecting" >
						<groomy-logo class="logo_center_bis"/>
						<p class="text-center message_chargement mb-0 mt-4">
							<font-awesome-icon class="spinner_home" :icon="['far', 'spinner']" pulse /><br/>{{ progressBarText }}
						</p>
					</div>

					<div v-else>
						<div class="text-center"><groomy-logo/></div>
						<p class="text-center mb-4 mt-4">{{ $t('global.app_description') }}</p>
						<form @submit.prevent="submitLogs">
							<div v-if="error_message" class="alert alert-warning">{{ error_message }}</div>
							<template v-if="!two_factor">
							<div class="form-group">
								<label>{{ $t('compte.email') }}</label>
								<input type="email" class="form-control" :placeholder="$t('compte.email')" id="mail_user" v-model="login">
							</div>
							<div class="form-group">
								<label>{{ $t("compte.password") }}</label>
								<input type="password" class="form-control" :placeholder="$t('compte.password')" id="password_user" v-model="password">
							</div>
							</template>
							<!-- Double authentification : le mot de passe est bon, on demande le code de l'application d'authentification -->
							<div v-else class="form-group">
								<!-- Compte administrateur sans double authentification : on l'active avant de le connecter -->
								<template v-if="two_factor_setup">
									<div class="alert alert-info">{{ $t('compte.two_factor.setup_required') }}</div>
									<p>{{ $t('compte.two_factor.setup_scan') }}</p>
									<div class="text-center mb-3">
										<img :src="two_factor_setup.qr" alt="QR code" width="200" height="200" class="bg-white p-2">
									</div>
									<p class="small">{{ $t('compte.two_factor.setup_manual') }} <code>{{ two_factor_setup.secret }}</code></p>
									<label for="code_user">{{ $t('compte.two_factor.setup_code') }}</label>
								</template>
								<template v-else>
									<label for="code_user">{{ $t('compte.two_factor.login_code') }}</label>
									<p class="small text-muted">{{ $t('compte.two_factor.login_help') }}</p>
								</template>
								<input type="text" class="form-control" ref="code_input" id="code_user" v-model="code" inputmode="numeric" autocomplete="one-time-code" maxlength="7" :placeholder="$t('compte.two_factor.login_code')">
							</div>
							<button id="button_submit" type="submit" title="Connexion" class="btn btn-primary rounded-pill btn-block mt-4 mb-3" :class="{disable: verrouAutoConnect}">
								{{ $t('compte.connexion') }}
							</button>

							<a v-if="two_factor" href="#" class="btn btn-link btn-block" @click.prevent="cancelTwoFactor">{{ $t('global.retour') }}</a>

							<!-- Si on a une connecition à internet, on peut proposer ces formulaires -->
							<router-link v-if="!two_factor" :to="{name: 'compteCreation'}"  :title="$t('compte.je_nai_pas_de_compte')" class="btn btn-link btn-block">{{ $t('compte.creer_compte') }} <font-awesome-icon :icon="['fal', 'angle-right']"/></router-link>
							<router-link v-if="!two_factor" :to="{name: 'resetPassword'}"  :title="$t('compte.j_ai_perdu_mdp')" class="btn btn-link btn-block">{{ $t('compte.mdp_oublie') }} <font-awesome-icon :icon="['fal', 'angle-right']"/></router-link>

							<div v-if="verrouAutoConnect">
								<p class="text-center"><font-awesome-icon v-if="verrouAutoConnect" :icon="['fal', 'spinner']" pulse/><br/>{{ $t('global.chargement') }} </p>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script type="text/javascript">
	import { EventBus } from 'EventBus'
	import Constants from '../../config.local.js'
	import UserMixin from '@/mixins/User.js'
	import Tools from '@/mixins/Tools.js'
	import Navigation from '@/mixins/Navigation.js'

	export default {
		name: "Home",
		mixins: [UserMixin, Tools, Navigation],
		components: {

		},
		data () {
			return {
				register_url: Constants.REGISTER_URL,
				reset_pwd_url: Constants.RESET_PWD_URL,
				login: '',
				password: '',
				connectivity: '',
				webservice_url: '',
				webservice_url_forgot_password: '',
				connecting: false,
				auto_connect: false,
				type_progress: '',
				error_message: "",
				two_factor: false,
				code: '',
				two_factor_setup: null
			}
		},
		mounted: async function() {
			// Si c'est le lancement de l'app, on affiche un message au démarrage de l'app
			if(!Constants.USER_ALREADY_LOGGED) {
				this.type_progress = "IAL"
				Constants.USER_ALREADY_LOGGED = true
			}
			this.init_component()
		},
		methods: {
			async submitLogs() {
				if(this.login != '' && this.password != '' && (!this.two_factor || this.code != '')) {
					this.connecting = true
					try {
						await this.loginUser(this.login, this.password, this.$route.query.redirect, false, this.two_factor ? this.code : null)
					} catch (err) {
						if(err.twoFactor) {
							// Le premier passage ne fait que demander le code : ce n'est pas une erreur à afficher
							this.error_message = this.two_factor ? err.message : ''
							if(!this.two_factor) {
								this.two_factor_setup = err.twoFactorSetup || null
							}
							this.two_factor = true
							this.code = ''
							this.$nextTick(() => this.$refs.code_input && this.$refs.code_input.focus())
						}
						else {
							this.error_message = err.message
							this.two_factor = false
							this.two_factor_setup = null
							this.code = ''
						}
                		this.returnToLogin()
					}
				}
			},
			cancelTwoFactor() {
				this.two_factor = false
				this.two_factor_setup = null
				this.code = ''
				this.password = ''
				this.error_message = ''
			},
			returnToLogin() {
				this.auto_connect = false
				this.connecting = false
			},
			init_component() {
				if(this.$route.query.als && this.$route.query.mail) {
					this.login = this.$route.query.mail
	                this.auto_connect  = true
	                this.autolog_token = this.$route.query.als
	                
	                this.submitAutoLog(this.login, this.autolog_token)
	                    .then(() => {
	                    	this.$nextTick(function () {
	                    		window.location.href = '/#/cards'
	                    	})
	                    })
	                    .catch(() => {
	                        this.returnToLogin()
	                    })
	            }
			}
		},
		computed: {
			progressBarText: function() {
				if(this.type_progress) {
					return this.getTrad('progression_message.'+this.type_progress)
				}
				return ""
			},
			verrouAutoConnect: function() {
				return this.auto_connect || this.connecting
			},
			verrouManualConnect: function() {
				return this.connecting
			}
		}
	};
</script>
